import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const SimpleTokenKey = 'Simple-Token'

export function getToken() {
  // return Cookies.get(TokenKey) || JSON.parse(localStorage.getItem('loginInfo'))?.userId;
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getSimpleToken() {
  // return Cookies.get(TokenKey) || JSON.parse(localStorage.getItem('loginInfo'))?.userId;
  return Cookies.get(SimpleTokenKey);
}

export function setSimpleToken(token) {
  return Cookies.set(SimpleTokenKey, token)
}

export function removeSimpleToken() {
  return Cookies.remove(SimpleTokenKey)
}
